export const createPointerIcon = (label) => {
  const charWidth = 10; 
  const width = label.length * charWidth ;
  const height = 50;
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" >
      <rect x="0" y="0.5" width="${width}" height="35" rx="10" ry="10" fill="#662D91" opacity="0.4" />
      <text x="50%" y="49%" font-size="14" text-anchor="middle" fill="white" dy="-2" font-family='"Roboto", sans-serif' letter-spacing="1">
        ${label}
      </text>
    </svg>
  `;
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: { width, height }
  };
};
